import styled from 'styled-components';

export const SMessage = styled.div`
    margin: 0.5rem 0 2.5rem;
    line-height: 1.6;
    text-align: center;
`;

export const SDaysRemaining = styled.span`
    font-weight: bold;
`;

const SPremiumBase = styled.span`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    background-color: ${({ theme }) => theme.color.premium.activated};
    border-radius: 50%;
    justify-content: center;
    margin-left: 0.25rem;
`;

export const SPremiumInline = styled(SPremiumBase)`
    svg {
        width: 1.3rem;
        height: 1.3rem;
    }

    width: 2rem;
    height: 2rem;
`;

export const SPremiumIcon = styled(SPremiumBase)`
    svg {
        width: 3.5rem;
        height: 3.5rem;
    }

    width: 6rem;
    height: 6rem;
`;
